module.exports = __webpack_public_path__ + "img/Board-Example.f64af871.gif";